import { isTauri as isTauriEnv } from '@tauri-apps/api/core';

/**
 * Runtime Tauri-WebView detection.
 *
 * Config-free by design: existing consumers call this at module scope
 * (`const IS_TAURI = isTauri()`), which evaluates before any bootstrap code
 * runs — so correct detection must never depend on `configurePlatform()`
 * having been called. The dev-time misconfiguration guard that used to live
 * here (the `NEXT_PUBLIC_IS_TAURI` validation in `src/tauri/utils.ts`) now
 * runs inside `configurePlatform()` (see ./config) — packages never read
 * `process.env` (G1/F5).
 */
export const isTauri = (): boolean => typeof window !== 'undefined' && isTauriEnv();
